import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import './SuperAdminDashboard.css';
import SupportTickets from './SupportTickets';

const SuperAdminDashboard = () => {
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('accounts');
  const history = useHistory();

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem('superAdminToken');
        if (!token) {
          history.push('/login');
          return;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const response = await axios.get(`${config.serverUrl}/superadmin/accounts`);
        setAccounts(response.data);
      } catch (error) {
        if (error.code === 'ERR_NETWORK') {
          setError('Cannot connect to server. Please check if the server is running.');
        } else if (error.response?.status === 401) {
          localStorage.removeItem('superAdminToken');
          history.push('/login');
        } else {
          setError('Failed to fetch accounts. Please try again later.');
        }
        console.error('Failed to fetch accounts:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAccounts();
  }, [history]);

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  const handleAccountClick = (accountId) => {
    history.push(`/account/${accountId}`);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="dashboard-container">
      <h1>Super Admin Dashboard</h1>
      <div className="tabs">
        <button 
          className={activeTab === 'accounts' ? 'active' : ''} 
          onClick={() => handleTabClick('accounts')}
        >
          Accounts
        </button>
        <button 
          className={activeTab === 'supportTickets' ? 'active' : ''} 
          onClick={() => handleTabClick('supportTickets')}
        >
          Support Tickets
        </button>
      </div>
      {activeTab === 'accounts' && (
        <table className="account-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Account Name</th>
              <th>Domain Name</th>
              <th>Date Created</th>
              <th>Default Language</th>
              <th>User Count</th>
              <th>Gallery Count</th>
              <th>Photos Count</th>
              <th>Storage Used (KB)</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map(account => (
              <tr key={account.id} onClick={() => handleAccountClick(account.id)}>
                <td>{account.id}</td>
                <td>{account.accountName}</td>
                <td>{account.domainName}</td>
                <td>{new Date(account.dateCreated).toLocaleDateString()}</td>
                <td>{account.defaultLanguage}</td>
                <td>{account.userCount}</td>
                <td>{(account.galleryCount || 0).toLocaleString()}</td>              
                <td>{(account.photosCount || 0).toLocaleString()}</td>
                <td>{(account.storageUsed || 0).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {activeTab === 'supportTickets' && <SupportTickets />}
    </div>
  );
};

export default SuperAdminDashboard;
